// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const passimian: PokeData = {
  "id": 766,
  "name": "passimian",
  "height": 20,
  "weight": 828,
  "base_experience": 172,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "leer",
    "focus-energy",
    "reversal",
    "scary-face",
    "rock-smash",
    "beat-up",
    "bulk-up",
    "close-combat",
    "fling",
    "giga-impact",
    "bestow"
  ],
  "moves": [
    "tackle",
    "leer",
    "scary-face",
    "rock-smash",
    "bulk-up",
    "close-combat",
    "jump-kick",
    "superpower",
    "drain-punch",
    "karate-chop",
    "coaching",
    "meteor-assault",
    "vacuum-wave"
  ],
  "evolution_chain": {
    "id": 395,
    "item": null,
    "species": [
      {
        "name": "passimian",
        "order": 766,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 122,
    "speed": 111,
    "ability_power": 167
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
